import { extendTheme, theme as chakraTheme } from '@chakra-ui/react';

const fonts = {
  heading: "Mulish, Avenir, sans-serif",
  body: "Mulish, Avenir, sans-serif",
};

const colors = {
  "blue": {
    "50": "#E6F3FF",
    "100": "#B8DEFF",
    "200": "#8AC8FF",
    "300": "#5CB3FE",
    "400": "#2F9EFE",
    "500": "#0188FE",
    "600": "#016DCB",
    "700": "#015298",
    "800": "#003766",
    "900": "#001B33"
  },
  "purple": {
    "50": "#F9E8FC",
    "100": "#EFBFF7",
    "200": "#E496F2",
    "300": "#DA6DED",
    "400": "#CF44E8",
    "500": "#C51CE3",
    "600": "#9D16B6",
    "700": "#761188",
    "800": "#4F0B5B",
    "900": "#27062D"
  },
  "orange": {
    "50": "#FFF4E5",
    "100": "#FFE0B8",
    "200": "#FFCD8A",
    "300": "#FFB95C",
    "400": "#FFA62E",
    "500": "#FF9200",
    "600": "#CC7500",
    "700": "#995800",
    "800": "#663A00",
    "900": "#331D00"
  },
  "green": {
    "50": "#ECFCE9",
    "100": "#CAF5C1",
    "200": "#A8EF9A",
    "300": "#86E972",
    "400": "#64E34A",
    "500": "#42DD22",
    "600": "#35B01C",
    "700": "#288415",
    "800": "#1A580E",
    "900": "#0D2C07"
  },
  "red": {
    "50": "#FAEBEA",
    "100": "#F2C6C4",
    "200": "#EAA19F",
    "300": "#E27C79",
    "400": "#DA5753",
    "500": "#D2322D",
    "600": "#A82824",
    "700": "#7E1E1B",
    "800": "#541412",
    "900": "#2A0A09"
  }
};

const theme = extendTheme(
  {
    fonts,
    colors,
    components: {
      Divider: {
        variants: {
          primary: {
            "&.chakra-divider": {
              border: `solid 1px ${chakraTheme.colors.gray[100]}`,
              borderLeft: 0,
              borderRight: 0,
              borderTop: 0,
            }
          }
        },
        defaultProps: {
          variant: "primary",
        }
      },
      Link: {
        variants: {
          primary: ({ colorScheme = "blue" }) => ({
            color: `${colorScheme}.500`,
            _hover: {
              color: `${colorScheme}.700`,
              textDecoration: "none"
            },
          }),
          text: () => ({
            color: "gray.700",
            _hover: {
              color: "blue.500",
              textDecoration: "none",
            }
          })
        },
        defaultProps: {
          variant: "primary",
        }
      },
      Modal: {
        variants: {
          ghost: () => ({
            dialog: {
              bg: 'transparent',
              shadow: 'none'
            }
          }),
        },
      },
    },
  },
);

export default theme;
